import React from 'react';
import { withRouter } from 'react-router-dom';
import Grid2 from './Grid2.jsx';

class FluxoProduto extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            gridHeader: [
                "Produto",
                "Conteúdo",
                "Unidades Disponíveis",
                "Data",
                "Fluxo",
                "Usuário" ],
            fluxo_estoque: [],
            id: 0,
            produto: "",
            embalagem: "",
            unidadeMedida: "",
            qtddEmbalagem: "",
            unidadesDisponiveis: "",
            ativo: "",
            centroId: 0,
            centro: "",
        };

        this.voltar = this.voltar.bind(this);
        this.gerarPDF = this.gerarPDF.bind(this);

    }

    decimalMask(str_val) {

        let res = ""; 
        let vec = str_val.split(",");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }

            c++;

        }

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",0";

        return res;

    }

    voltar() {

        let obj = {
            row: {
                id: this.state.id,
                data: [
                    this.state.produto,
                    this.state.embalagem,
                    this.state.unidadeMedida,
                    this.state.qtddEmbalagem,
                    this.state.unidadesDisponiveis,
                    this.state.ativo
                ]
            }
        };

        this.props.history.push({
            pathname: "/visualizarproduto",
            state: obj
        });

    }

    gerarPDF() {

        this.setState({ disabled: true });
        this.props.waitMsgHandler("Aguardando");

        fetch("/api/fluxo_estoque/produto/relatorio/" + this.state.id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            if (responseJson.msg === "success") {

                let obj = {
                    "file_name": responseJson.file
                };

                fetch("/api/fluxo_estoque/produto/relatorio/download", {
                    method: "POST",
                    headers: {
                        "Content-type": "application/json",
                        "Authorization": "Basic " + btoa(localStorage.auth)
                    },
                    mode: "cors",
                    body: JSON.stringify(obj)
                })
                .then(response2 => response2.blob())
                .then(blob => {

                    this.props.waitMsgHandler("");
                    this.setState({ disabled: false });

                    let url = window.URL.createObjectURL(blob);
                    let a = document.createElement("a");
                    a.href = url;
                    a.download = responseJson.file;
                    a.click();

                });

            }

        });

    }

    componentDidMount() {

        if (localStorage.roleEstoque === "nenhuma") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/estoque";
        }

        let id = this.props.location.state.id;
        let produto = this.props.location.state.produto;
        let embalagem = this.props.location.state.embalagem;
        let unidadeMedida = this.props.location.state.unidadeMedida;
        let qtddEmbalagem = this.props.location.state.qtddEmbalagem;
        let unidadesDisponiveis = this.props.location.state.unidadesDisponiveis;
        let ativo = this.props.location.state.ativo;
        let centroId = this.props.location.state.centroId;
        let centro = this.props.location.state.centro;

        this.setState({ id: id });
        this.setState({ produto: produto });
        this.setState({ embalagem: embalagem });
        this.setState({ unidadeMedida: unidadeMedida });
        this.setState({ qtddEmbalagem: qtddEmbalagem });
        this.setState({ unidadesDisponiveis: unidadesDisponiveis });
        this.setState({ centroId: centroId });
        this.setState({ centro: centro });

        if (ativo === 0) {
            this.setState({ ativo: false });
        } else {
            this.setState({ ativo: true });
        }

        fetch("/api/fluxo_estoque/produto/grid/" + id, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ fluxo_estoque: responseJson });

        });

    }

    render() {
        return(
            <div>
                <h1 id="fluxo-produto-title">Fluxo do Produto</h1><br />
                <p id="fluxo-produto-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br />
                <p id="fluxo-produto-produto">
                    <b>Produto: </b>
                    { this.state.produto }
                    { " (" }
                    { this.state.embalagem }
                    { " de " }
                    { this.decimalMask(this.state.qtddEmbalagem) }
                    { " " }
                    { this.state.unidadeMedida }
                    { ")" }
                </p><br /><br />
                <Grid2 key={ this.state.fluxo_estoque }
                    header={ this.state.gridHeader }
                    data={ this.state.fluxo_estoque }
                    pageSize={ 10 }
                    gridWidth={ "800px" } />
                <br />
                <button id="fluxo-produto-voltar-btn" onClick={ this.voltar }>
                    Voltar
                </button>
                <button id="fluxo-produto-gerar-btn"
                    onClick={ this.gerarPDF }
                    disabled={ this.state.disabled }>
                    Gerar PDF
                </button><br /><br />
            </div>
        );
    }

}

export default withRouter(FluxoProduto);

